import React from "react";

import {Loader} from "../../components/loading/Loader";
import {StyledTable} from "../../components/styledTable/StyledTable";

import {useGetOrdersByEvent} from "../../services/api/event/order/getOrdersByEvent/useGetOrdersByEvent";
import {useGetEvent} from "../../services/api/event/getEvent/useGetEvent";
import {InfoCard} from "../../components/infoCard/InfoCard";
import {useCreateColumns} from "../../components/styledTable/useCreateColumns";
import {
  buildColumnData,
  buildFiltrableColumns,
  getGrossSalesFromOrders,
  getLatestOrderFromOrders,
} from "./ordersHelper";

import styles from "./Orders.module.scss";

export default function Orders() {
  const {data: orderData, isPending: isOrderDataPending} =
    useGetOrdersByEvent();
  const {data: event, isPending: isEventPending} = useGetEvent();

  const eventQuestions = event?.eventQuestions ?? [];

  const columnData = useCreateColumns({
    tableData: orderData ?? [],
    columnData: buildColumnData(eventQuestions),
  });

  if (!orderData || !event || isOrderDataPending || isEventPending)
    return <Loader type="color" />;

  const TableInfoCards = () => {
    return (
      <div className={styles.tableInfoCards}>
        <InfoCard title="Total Orders" subtitle={orderData.length} />
        <InfoCard
          title="Gross Sales"
          subtitle={getGrossSalesFromOrders(orderData)}
        />
        <InfoCard
          title="Latest Order"
          subtitle={getLatestOrderFromOrders(orderData)}
        />
      </div>
    );
  };

  return (
    <div className={styles.screen}>
      <TableInfoCards />
      <StyledTable
        data={orderData ?? []}
        columns={columnData}
        showPagination={true}
        filterableColumns={buildFiltrableColumns(eventQuestions)}
      />
    </div>
  );
}
